export default function formatBeverlyWilshire(name) {
	if (name === 'Beverly Wilshire, A Four Seasons Hotel') {
		return `Beverly Wilshire, <span class="font-20">A Four Seasons Hotel</span>`;
	}
	return name;
}
